import React, { useMemo } from "react";

import Tag from "antd/es/tag";
import { defineMessages, useIntl } from "react-intl";

import { EntitySupportingCard } from "@mapmycustomers/shared/types/entity";
import { isNotEmpty } from "@mapmycustomers/shared/util/assert";

import EmailSubscriptionStatusTag from "@app/component/EmailSubscriptionStatusTag";
import FrequencyStateLink from "@app/component/frequency/FrequencyStateLink";
import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";
import { UniversalFieldName } from "@app/util/fieldModel/universalFieldsFieldModel";

import styles from "./EntityActivities.module.scss";

interface Props {
  children?: React.ReactNode;
  emailSubscribed?: boolean | null;
  entity: EntitySupportingCard;
}

const messages = defineMessages({
  lastContact: {
    id: "recordCard.lastContact",
    defaultMessage: "Last contact: {value}",
    description: "Last contact - formatted date",
  },
  lastContactNever: {
    id: "recordCard.lastContact.never",
    defaultMessage: "Not yet contacted",
    description: "Last contact - not yet contacted",
  },
});

const EntityActivities: React.FC<Props> = ({ children, emailSubscribed, entity }) => {
  const intl = useIntl();
  const isVisible = true;

  const lastCompletedActivity = useMemo(() => {
    const field = getFieldModelByEntityType(entity.entity).getByName(
      UniversalFieldName.LAST_ACTIVITY_DATE
    );
    return field ? field.getFormattedValueFor(entity) : undefined;
  }, [entity]);

  return isVisible ? (
    <div className={styles.container}>
      {isNotEmpty(emailSubscribed) && (
        <EmailSubscriptionStatusTag emailSubscribed={emailSubscribed} />
      )}
      <Tag>
        {lastCompletedActivity
          ? intl.formatMessage(messages.lastContact, { value: lastCompletedActivity })
          : intl.formatMessage(messages.lastContactNever)}
      </Tag>
      <FrequencyStateLink entity={entity} />
      {children && <div className={styles.children}>{children}</div>}
    </div>
  ) : null;
};

export default EntityActivities;
